import React from "react";
import { AppIcons } from "../../data/appIcons";
import "./ResetPassword.scss";
import Image from "../../components/image/Image";
import ResetPasswordMain from "./features/ResetPassword";

export const ResetPassword = () => {
  return (
    <>
      {/* <div className="resetpass-main-section">
        <div className="container-fluid">
          <div className="resetpass-main">
            <div className="row align-items-center">
              <div className="col-xl-5 col-6">
                <div className="resetpass-form-sec">
                  <div className="logo-img">
                    <h1>
                      Reset Password
                    </h1>
                  </div>
                  <div className="resetpass-form-desc">
                    <h3>Enter your account Details</h3>
                    <p>
                      There are many variations of passages of Lorem Ipsum
                      available, in some form, by injected humour
                    </p>
                  </div>
                  <div className="resetpass-form-part">
                    <ResetPasswordMain />
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-6">
                <div className="right-img-part">
                  <h3>Task Management System</h3>
                 
                  <Image
                    imagePath={AppIcons.LoginImg}
                    altText="ResetPass Vector"
                  ></Image>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="copyright-txt">
                  <p>
                    Task Management System © {new Date().getFullYear()} All
                    rights reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="login-main-section">
        <div className="login-container">
          <div className="login-content">
            <div className="login-form-sec">
              <h1 className="logo-img">
                <Image imagePath={AppIcons.logoImage} altText="Login Vector" />
              </h1>
              <h1 className="logo-text">Task Manager</h1>
              <h6>Reset Password</h6>
              <div className="login-form-part">
                <ResetPasswordMain />
              </div>
            </div>
            <div className="login-background">
              <Image imagePath={AppIcons.LoginImg} altText="Login Vector" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
